import type { Locale, NodeType } from '../data/schema'
import { copy } from '../i18n'
import { Icon } from './Icon'
import { TypeIcon } from './TypeIcon'

const types: NodeType[] = ['deity', 'hero', 'mortal', 'creature', 'place', 'event', 'artifact']
export type RelationshipLabelMode = 'always' | 'auto' | 'focus'

export function FilterPanel({ locale, active, labelMode, onLabelMode, onToggle, onResetTypes, onClose }: { locale: Locale; active: Set<NodeType>; labelMode: RelationshipLabelMode; onLabelMode: (mode: RelationshipLabelMode) => void; onToggle: (type: NodeType) => void; onResetTypes: () => void; onClose: () => void }) {
  const t = copy[locale]
  return (
    <section className="filter-panel" aria-label={t.filter}>
      <header><div><span className="eyebrow">ATLAS LAYERS</span><h2>{t.filter}</h2></div><button className="icon-button" onClick={onClose} aria-label={t.close}><Icon name="close" /></button></header>
      <p>{t.allTypes}</p>
      <div className="filter-options">
        {types.map((type) => (
          <label key={type}>
            <input type="checkbox" checked={active.has(type)} onChange={() => onToggle(type)} />
            <span className={`type-sigil ${type}`}><TypeIcon type={type} /></span>
            <span>{t.nodeTypes[type]}</span>
          </label>
        ))}
      </div>
      {active.size < types.length && <button type="button" className="filter-reset" onClick={onResetTypes}>
        {locale === 'en' ? 'Show all node types' : '重新顯示所有類型'}
      </button>}
      <div className="filter-focus-note">{locale === 'en' ? 'The current focus stays visible when you filter by type.' : '按類型篩選時，目前焦點仍會顯示。'}</div>
      <p>{t.relationshipLabels}</p>
      <div className="label-mode" role="group" aria-label={t.relationshipLabels}>
        {(['always', 'auto', 'focus'] as const).map((mode) => (
          <button key={mode} className={labelMode === mode ? 'active' : ''} onClick={() => onLabelMode(mode)} aria-pressed={labelMode === mode}>
            {mode === 'always' ? t.labelAlways : mode === 'auto' ? t.labelAuto : t.labelFocus}
          </button>
        ))}
      </div>
      <div className="legend-note">{locale === 'en' ? 'Colour, shape and symbol work together.' : '顏色、形狀與符號共同區分類型。'}</div>
    </section>
  )
}
